"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.associateBy = associateBy;
function associateBy(arr, getKey) {
    const map = new Map();
    arr.forEach((value) => {
        const key = getKey(value);
        map.set(key, value);
    });
    return map;
}
